export default __webpack_public_path__ + "locales/el-GR/EmptyTrashDialog.json?hash=a4a3f48dd09ee04014405fd2de3d6307";